import { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import ServerCard from '../components/ServerCard';
import { api } from '../services/api';
import { Server, Sparkles, Sun, Moon } from 'lucide-react';
import '../styles/Servers.css';

const Servers = () => {
  const { t } = useLanguage();
  const { isActive, isAdmin } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [servers, setServers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isActive || isAdmin) {
      api.servers.getAll()
        .then(data => {
          setServers(Array.isArray(data) ? data : []);
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [isActive, isAdmin]);

  if (!isActive && !isAdmin) {
    return <div className="container text-center mt-8 text-danger">Access Denied</div>;
  }

  return (
    <div className={`servers-page ${theme}`}>
      <div className="servers-glow-1"></div>
      <div className="servers-glow-2"></div>

      <div className="servers-container">
        <div className="servers-section-header">
          <h2>
            <Sparkles size={28} />
            {t('servers')}
          </h2>
          <p>{t('widgetsPageSubtitle')}</p>
        </div>

        {loading ? (
          <div className="servers-loading">
            <div className="servers-spinner"></div>
            <span>Loading...</span>
          </div>
        ) : servers.length === 0 ? (
          <div className="servers-empty">
            <Server size={48} />
            <p>{t('noServers')}</p>
          </div>
        ) : (
          <div className="servers-grid">
            {servers.map(server => (
              <ServerCard
                key={server.id}
                server={server}
                isAdmin={isAdmin}
                onEdit={() => {}}
                onDelete={() => {}}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Servers;
